var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 114,
    viewBox: "0 0 113 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_625_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4739 53.0046C14.0655 49.2314 9.36133 47.3448 9.36133 45.0005C9.36133 42.6561 14.0655 40.7695 23.4739 36.9964L36.7793 31.6603C46.1877 27.8871 50.8919 26.0005 56.7375 26.0005C62.5831 26.0005 67.2872 27.8871 76.6956 31.6603L90.001 36.9964C99.4094 40.7695 104.114 42.6561 104.114 45.0005C104.114 47.3448 99.4094 49.2314 90.001 53.0046L76.6956 58.3407C67.2872 62.1139 62.5831 64.0005 56.7375 64.0005C50.8919 64.0005 46.1877 62.1139 36.7793 58.3407L23.4739 53.0046Z",
    fill: "url(#paint0_linear_625_281)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36133 45.0005C9.36133 47.3448 14.0655 49.2314 23.4739 53.0046L36.7793 58.3407C46.1877 62.1139 50.8919 64.0005 56.7375 64.0005C62.5831 64.0005 67.2872 62.1139 76.6956 58.3407L90.001 53.0046C99.4094 49.2314 104.114 47.3448 104.114 45.0005C104.114 42.6561 99.4094 40.7695 90.001 36.9964L76.6956 31.6603C67.2872 27.8871 62.5831 26.0005 56.7375 26.0005C50.8919 26.0005 46.1877 27.8871 36.7793 31.6603L23.4739 36.9964C14.0655 40.7695 9.36133 42.6561 9.36133 45.0005Z",
    fill: "url(#paint1_linear_625_281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.001 72.0046L76.6956 77.3407C67.2872 81.1139 62.5831 83.0005 56.7375 83.0005C50.8919 83.0005 46.1877 81.1139 36.7793 77.3407L23.4739 72.0046C14.0655 68.2314 9.36133 66.3448 9.36133 64.0005C9.36133 61.8873 13.1837 60.146 20.8284 57.0596L35.7092 63.0276C44.4674 66.5418 49.9719 68.7505 56.7375 68.7505C63.503 68.7505 69.0075 66.5418 77.7657 63.0276L92.6465 57.0596C100.291 60.146 104.114 61.8873 104.114 64.0005C104.114 66.3448 99.4094 68.2314 90.001 72.0046Z",
    fill: "url(#paint2_linear_625_281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.001 91.0038L76.6956 96.3399C67.2872 100.113 62.5831 102 56.7375 102C50.8919 102 46.1877 100.113 36.7793 96.3399L23.4739 91.0038C14.0655 87.2306 9.36133 85.344 9.36133 82.9996C9.36133 80.8864 13.1837 79.1451 20.8284 76.0587L35.7092 82.0267C44.4674 85.5409 49.9719 87.7496 56.7375 87.7496C63.503 87.7496 69.0075 85.5409 77.7657 82.0267L92.6465 76.0587C100.291 79.1451 104.114 80.8864 104.114 82.9996C104.114 85.344 99.4094 87.2306 90.001 91.0038Z",
    fill: "url(#paint3_linear_625_281)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_625_281",
    x: 0,
    y: -3,
    width: 113,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_625_281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_625_281",
    x1: 13.6449,
    y1: 36.9839,
    x2: 112.989,
    y2: 56.2605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_625_281",
    x1: 13.6449,
    y1: 36.9839,
    x2: 112.989,
    y2: 56.2605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_625_281",
    x1: 13.6449,
    y1: 36.9839,
    x2: 112.989,
    y2: 56.2605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_625_281",
    x1: 13.6449,
    y1: 36.9839,
    x2: 112.989,
    y2: 56.2605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.8096308a07bc512871b004e2af9a3159.svg";
export { ForwardRef as ReactComponent };